// Libs
import React, { useEffect, useState } from 'react';

// Own Libs
import { SimpleView, CompositeView, GridView } from '@digital/ui';

//Api
import {
  DemandaComRequisicao,
  getAllDemandasComRequisicaoComStatus
} from '@app/api/requisitanteCapex';

//Files
import TabelaDemandas from '../tabelaDemandas';
import { EStatusDemanda } from '@app/enums/EStatusDemanda';

//Utils

const RequisitanteCapex = () => {
  const result: DemandaComRequisicao[] = [];
  const [demandasComRequisicaoComStatus3, setDemandasComRequisicaoComStatus3] = useState<DemandaComRequisicao[]>();

  const allDemandasComRequisicaoComStatus3 = async () => {
    const resultDemanda = await getAllDemandasComRequisicaoComStatus(EStatusDemanda.AguardandoRCDemandante);
    if (resultDemanda) setDemandasComRequisicaoComStatus3(resultDemanda);
  };

  useEffect(() => {
    allDemandasComRequisicaoComStatus3();
  }, []);

  return (
    <SimpleView>
      <CompositeView>
        <GridView title="Pendencias requisitante Capex" icon="ui-in_progress" id="aguardandoGeracaoRequisicaoCompra" noform>
          <TabelaDemandas
            idtabela="mrn-tabela-aguardandoGeracaoRequisicaoCompra"
            dataSourceResult={demandasComRequisicaoComStatus3 ? demandasComRequisicaoComStatus3 : result}
            widgettitle={'Aguardando Geração Requisição de Compra'}
            urlDemanda={'/demanda/questionario/'}
            aba={'/demanda'}
          />
        </GridView>
      </CompositeView>
    </SimpleView>
  );
};
export default RequisitanteCapex;
